var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconsLoader',{staticClass:"app-loader",attrs:{"size":_vm.loaderSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }